// Actions
import {
  REQUEST_STARTED,
  REQUEST_SUCCEEDED,
  REQUEST_SUCCEEDED_LITE,
  REQUEST_FAILED,
  REQUEST_REGION_SELECT,
  SET_COORDINATES,
  SET_ADDRESS,
} from '../actions/createData';

const init = {
  data: [],
  error: null,
  request: false,
  geoJson: {},
  region: 'NSW',
  coords: [],
  circRadius: 2,
  partyData: [],
  dataRadius: [],
  geoPP: {
    type: 'FeatureCollection',
    features: [],
  },
  address: '',
  parties: [],
  totalVotes: 0,
};

export default function data(state = init, action) {
  switch (action.type) {
    case REQUEST_STARTED:
      return { ...state, request: true };

    case REQUEST_SUCCEEDED:
      // console.log('action.data ', action.data);
      return {
        ...state,
        data: action.data,
        request: false,
        partyData: action.partyData,
        geoPP: action.geoPP,
        dataRadius: action.dataRadius,
        parties: action.parties,
        totalVotes: action.totalVotes,
      };

    case REQUEST_SUCCEEDED_LITE:
      return {
        ...state,
        data: action.data,
        request: false,
      };

    case REQUEST_FAILED:
      return { ...state, request: false, error: action.error };

    case REQUEST_REGION_SELECT:
      console.log('action.region ', action.region);
      return { ...state, region: action.region };

    case SET_COORDINATES:
      return { ...state, coords: action.coords };

    case SET_ADDRESS:
      return { ...state, address: action.address };

    default:
      return state;
  }
}
